import Service from "../../services/Service";

const service = new Service();

export const profileActionTypes = {
    PORTFOLIOS_REQUEST: 'PORTFOLIOS_REQUEST',
    PORTFOLIO_REQUEST: 'PORTFOLIO_REQUEST',
    PORTFOLIO_DELETE: 'PORTFOLIO_DELETE',
    USER_PORTFOLIO_UPDATE: 'USER_PORTFOLIO_UPDATE',
    USERNAME_UPDATE:'USERNAME_UPDATE',
    IMPORT:'IMPORT',
    EMPTY_PROFILE: 'EMPTY_PROFILE',
    EDIT_TRANSACTION: 'EDIT_TRANSACTION'
}

export const getPortfolios = () => (dispatch) => {
    dispatch({
        type: profileActionTypes.PORTFOLIOS_REQUEST,
        payload: {
            isLoad: true
        }
    })
    return service.getPortfolios()
        .then(response => {
            console.log(response);
            const { ...headers } = response.headers || {}
            const [ ...data ] = response.data || []

            dispatch({
                type: profileActionTypes.PORTFOLIOS_REQUEST,
                payload: {
                    list: data,
                    isLoad: false
                }
            })
        })
        .catch(err => {
            console.log(err);
            const { ...data } = err?.response || {}

            dispatch({
                type: profileActionTypes.PORTFOLIOS_REQUEST,
                payload: {
                    isLoad: false
                }
            })
        })
}

export const getPortfolio = (pk) => (dispatch) => {
    dispatch({
        type: profileActionTypes.PORTFOLIO_REQUEST,
        payload: {
            isLoad: true
        }
    })
    return service.getPortfolio(pk)
        .then(response => {
            console.log(response);
            const { ...headers } = response.headers || {}
            const { ...data } = response.data || {}

            dispatch({
                type: profileActionTypes.PORTFOLIO_REQUEST,
                payload: {
                    data,
                    isLoad: false
                }
            })
        })
        .catch(err => {
            console.log(err);
            const { ...data } = err?.response || {}

            dispatch({
                type: profileActionTypes.PORTFOLIO_REQUEST,
                payload: {
                    isLoad: false
                }
            })
        })
}

export const updateUserPortfolio = (pk) => (dispatch) => {
    return dispatch({
        type: profileActionTypes.USER_PORTFOLIO_UPDATE,
        payload: {
            portfolio: pk
        }
    })
}

export const updateUsername = (username) => (dispatch) => {
    return dispatch({
        type: profileActionTypes.USERNAME_UPDATE,
        payload: {
            username: username
        }
    })
}

export const sendDeals = (props) => (dispatch) => {
    dispatch(
        {
            type: profileActionTypes.IMPORT,
            payload: {
                isLoad: true
            }
        }
    )

    return service.sendDeals(props)
        .then(response => {
            console.log(response);
            const { ...headers } = response.headers || {}
            const { ...data } = response.data || {}
            dispatch(
                {
                    type: profileActionTypes.IMPORT,
                    payload: {
                        isLoad: false
                    }
                }
            )
        })
        .catch(err => {
            console.log(err);
            const { ...data } = err?.response || {}

            dispatch(
                {
                    type: profileActionTypes.IMPORT,
                    payload: {
                        isLoad: false
                    }
                }
            )
        })
}

export const updateImport = (props) => (dispatch) => {
    dispatch(
        {
            type: profileActionTypes.IMPORT,
            payload: {
                import: props
            }
        }
    )
}

export const isEmptyProfile = (props) => (dispatch) => {
    dispatch(
        {
            type: profileActionTypes.EMPTY_PROFILE,
            payload: {
                isEmpty: props
            }
        }
    )
}

export const editTransaction = (props) => (dispatch) => {
    dispatch(
        {
            type: profileActionTypes.EDIT_TRANSACTION,
            payload: {
                transaction: props
            }
        }
    )
}
// export const createPortfolio = (props) => (dispatch) => {
// }
// export const deletePortfolio = (pk) => (dispatch) => {
// }